import { SentryTrackingConfig } from '@arianee/arn-types';
import * as Sentry from '@sentry/browser';
import { BrowserTracing } from '@sentry/tracing';

export class SentryTrackingService {
  constructor(sentryConfig: SentryTrackingConfig) {
    const dsn = sentryConfig.dsn;
    if (dsn) {
      Sentry.init({
        dsn: dsn,
        integrations: [new BrowserTracing()],
        tracesSampleRate: sentryConfig.tracesSampleRate,
      });
    } else {
      console.warn('No Sentry DSN');
    }
  }
}
